import React from "react";
import PropTypes from "prop-types";

// Get icon types from assets
import iconTypes from "../../assets/svg/index";

const SvgComponent = ({ name, ...props }) => {
  const Icon = iconTypes[name];
  return <Icon {...props} />;
};

SvgComponent.propTypes = {
  name: PropTypes.string,
};

export default SvgComponent;
